import React, { Component } from 'react';
import { connect } from 'shalala';
import { Row, Col } from 'react-bootstrap';
import { Guardian } from '@xaamin/guardian';

import { useStore } from '../../../store';
import AutofacturacionList from './list/AutofacturacionList';
import SearchByDatesAndKeyword from '../../../shared/SearchByDatesAndKeyword';
import AutofacturacionItemActions from './list/components/AutofacturacionItemActions';
import AutofacturacionListActions from './list/components/AutofacturacionListActions';

class AutofacturacionFiles extends Component {
  state = {
    selectedRowKeys: [],
    selectedRows: [],
  };

  componentDidMount() {
    window.setAppTitle('Autofacturación');
  }

  handleOnRowSelectionChange = ({ selectedRowKeys, selectedRows }) => {
    this.setState({
      selectedRowKeys,
      selectedRows,
    });
  };

  handleOnRowClick = (data) => {
    this.props.history.push({
      pathname: `/modulos/autofacturacion/${data.id}/info`,
      state: {
        data: { ...data },
      },
    });
  };

  handleOnDateChange = (values) => {
    this.props.paginate(values);
  };

  handleOnKeywordChange = (search) => {
    this.props.paginate({ search });
  };

  render() {
    const { selectedRowKeys, selectedRows } = this.state;
    const { from, to } = this.props.pagination;

    return (
      <>
        <Row>
          <Col
            sm="auto"
            md="8"
            className="mb-2"
          >
            {selectedRowKeys.length > 0 && (
              <div className="mr-3 d-inline-flex pb-2">
                <AutofacturacionItemActions
                  selectedRowKeys={selectedRowKeys}
                  selectedRows={selectedRows}
                  alignRight={false}
                />
              </div>
            )}

            {selectedRowKeys.length === 0 && (
              <SearchByDatesAndKeyword
                from={from}
                to={to}
                onDateChange={this.handleOnDateChange}
                onKeywordChange={this.handleOnKeywordChange}
              />
            )}
          </Col>

          <Col
            sm="auto"
            md="4"
            className="text-right pb-2"
          >
            <AutofacturacionListActions />
          </Col>
        </Row>

        {Guardian.allows('autofacturacion.listar.archivos') && (
          <AutofacturacionList
            onRowClick={this.handleOnRowClick}
            selectedRowKeys={selectedRowKeys}
            selectedRows={selectedRows}
            onRowSelectionChange={this.handleOnRowSelectionChange}
          />
        )}
      </>
    );
  }
}

const mapState = (store) => {
  return store.modulo.autofacturacion.archivos;
};

const mapActions = (actions) => {
  return actions.modulo.autofacturacion.archivos;
};

export default connect(useStore, mapState, mapActions)(AutofacturacionFiles);
